'use client';

import { useEffect } from 'react';
import { BUILD_TIMESTAMP, ONL_BUILD, ONL_BUILD_NOTE } from '@/lib/buildStamp';
import { isDevMode } from '@/lib/devMode';

/**
 * Logs build stamp once on app boot (dev mode only)
 * Uses ONL_BUILD for deployment verification
 */
export function BuildStampLogger() {
  useEffect(() => {
    if (isDevMode()) {
      console.log("[ONL_BUILD]", ONL_BUILD, ONL_BUILD_NOTE);
    }
  }, []);

  return null;
}
